import { render, staticRenderFns } from "./abnormalList.vue?vue&type=template&id=78b4f0a6&scoped=true&"
import script from "./abnormalList.vue?vue&type=script&lang=ts&"
export * from "./abnormalList.vue?vue&type=script&lang=ts&"
import style0 from "./abnormalList.vue?vue&type=style&index=0&id=78b4f0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b4f0a6",
  null
  
)

export default component.exports